import { Identifier } from 'react-admin';
import { axiosInstance } from 'services/http';
import {
  JobRepairBuilderSupervisorEmailDto,
  JobRepairDataDto,
} from '@vatos-pas/common';

const getEmailContent = async (repairId: Identifier) => {
  const builderSupervisorEmail =
    await axiosInstance.get<JobRepairBuilderSupervisorEmailDto>(
      `/job-repair/${repairId}/builder-supervisor-email`,
    );

  return builderSupervisorEmail.data;
};

const getLoggedUserInfo = async (id: Identifier) => {
  const userLogged = await axiosInstance.get<any>(`/user/${id}`);

  return userLogged.data;
};

interface SupervisorsData {
  name: string;
  phoneNumber: string;
  email: string;
}

const getBuilderSupervisorEmailBody = (
  jobRepairData: JobRepairDataDto,
  supervisorsData: SupervisorsData,
) => {
  // API returns repair description (e.g. "H/O Service") instead of RepairTypeEnum value
  const scheduledForLine =
    jobRepairData.repairType === 'H/O Service'
      ? 'This repair is scheduled for:\r\n\r\n'
      : '';

  return `Greetings,\r\n\r\n${scheduledForLine}Please approve the following and send the PO or a payment screenshot by replying to ${
    supervisorsData.email
  }\r\n\r\n\u2003\u2003\u2003${jobRepairData?.zip}\r\n\r\n\u2003\u2003\u2003$ ${
    jobRepairData.poAmount
  }\r\n\u2003\u2003\u2003${
    jobRepairData?.jobRepairDescription || ''
  }\r\n\u2003\u2003\u2003\r\n\u2003\u2003\u2003Vatos Supervisor\r\n\u2003\u2003\u2003${
    supervisorsData?.name
  }\r\n\u2003\u2003\u2003${
    supervisorsData?.phoneNumber
  }\r\n\u2003\u2003\u2003\r\n\u2003\u2003\u2003\u2003\u2003\u2003\u2003\u2003\u2003\u2003\u2003\u2003\u2003\u2003\u2003\u2003\u2003\u2003\u2003\u2003\u2003\u2003\u2003\u2003\u2003\u2003\u2003\u2003\u2003\u2003\u2003\u2003\u2003\u2003\u2003\u2003\u2003\u2003\u2003\u2003\u2003\u2003\u2003\u2003\u2003\u2003Vatos Drywall\r\n\u2003\u2003\u2003\u2003\u2003\u2003\u2003\u2003\u2003\u2003\u2003\u2003\u2003\u2003\u2003\u2003\u2003\u2003\u2003\u2003\u2003\u2003\u2003\u2003\u2003\u2003\u2003\u2003\u2003\u2003\u2003\u2003\u2003\u2003\u2003\u2003\u2003\u2003\u2003\u2003Phone: 407-365-3303
`;
};

const openEmailClient = (to: string, body: string, subject: string) => {
  window.location.href = `mailto:${to}?body=${encodeURI(
    body,
  )}&subject=${subject}`;
};

const sendMail = async (repairId: Identifier | undefined) => {
  if (!repairId) return;

  const builderSupervisorEmail: any = await getEmailContent(repairId);

  const userId: string = localStorage.getItem('userId') || '';
  const userInfo = await getLoggedUserInfo(userId);

  if (!userInfo) return;

  const builderSupervisorEmailBody = getBuilderSupervisorEmailBody(
    builderSupervisorEmail.jobRepairData,
    {
      name: userInfo.firstName + ' ' + userInfo.lastName,
      email: userInfo.email,
      phoneNumber: userInfo.primaryPhone,
    },
  );

  const emailDestination = builderSupervisorEmail.to?.join(';');

  const { subDivisionName, lot, repairType, poAmount } =
    builderSupervisorEmail.jobRepairData;

  const subject =
    [subDivisionName, lot, repairType || 'Repair'].filter(Boolean).join(' ') +
    ` - $${Number(poAmount).toFixed(2)}`;

  openEmailClient(emailDestination, builderSupervisorEmailBody, subject);
};

export { sendMail };
